import { render } from "./TeamSection.vue?vue&type=template&id=516d905a"
import script from "./TeamSection.vue?vue&type=script&lang=js"
export * from "./TeamSection.vue?vue&type=script&lang=js"

import "./TeamSection.vue?vue&type=style&index=0&id=516d905a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__